export const ONBOARDING_STEP = {
  setting_up: "setting_up",
  completed: "completed",
} as const;

export const BUSINESS_TYPE = {
  sole_proprietorship: "sole_proprietorship",
  partnership: "partnership",
  llc: "llc",
  c_corporation: "c_corporation",
  s_corporation: "s_corporation",
  non_profit: "non_profit",
};

export const BUSINESS_TYPE_TO_LABEL = {
  [BUSINESS_TYPE.sole_proprietorship]: "Sole Proprietorship",
  [BUSINESS_TYPE.partnership]: "Partnership",
  [BUSINESS_TYPE.llc]: "LLC",
  [BUSINESS_TYPE.c_corporation]: "C Corporation",
  [BUSINESS_TYPE.s_corporation]: "S Corporation",
  [BUSINESS_TYPE.non_profit]: "Non-Profit",
};

export const BUSINESS_TYPE_OPTIONS = Object.values(BUSINESS_TYPE).map(
  (type) => ({
    label: BUSINESS_TYPE_TO_LABEL[type],
    value: type,
  }),
);

export const BUSINESS_DETAILS_FIELD_NAME_TO_LABEL = {
  legal_business_name: "Legal Business Name",
  dba: "DBA Name",
  website_url: "Website URL",
  business_description: "Business Description",
  ein: "EIN",
  date_of_incorporation: "Date of Incorporation",
  incorporation_state: "Incorporation State",
  company_type: "Business Type",
  email: "Email",
  phone_number: "Phone Number",
  "address_attributes.line_one": "Address Line 1",
  "address_attributes.line_two": "Address Line 2",
  "address_attributes.city": "City",
  "address_attributes.state": "State",
  "address_attributes.zip_code": "ZIP Code",
} as const;

export const UBO_FIELD_NAME_TO_LABEL = {
  "ubos.first_name": "First Name",
  "ubos.last_name": "Last Name",
  "ubos.title": "Title",
  "ubos.ownership_percent": "Ownership Percentage",
  "ubos.email": "Email",
  "ubos.phone_number": "Phone Number",
  "ubos.date_of_birth": "Date of Birth",
  "ubos.ssn": "SSN",
  "ubos.address_attributes.line_one": "Address Line 1",
  "ubos.address_attributes.line_two": "Address Line 2",
  "ubos.address_attributes.city": "City",
  "ubos.address_attributes.state": "State",
  "ubos.address_attributes.zip_code": "ZIP Code",
};
